// extracted by mini-css-extract-plugin
module.exports = {"container":"i_BH","tags":"i_BI","tag":"i_BJ"};